import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./region-summary-popup.module.scss";
import {
    selectActiveFeature,
    selectFilteredProjectsInActiveFeature,
} from "../../reducers/";
function RegionSummaryPopup({ projects, activeFeature, nameSelector }) {
    return (
        <div className={styles.container}>
            <p className={styles.paragraph}>
                There are <strong>{projects.length}</strong> innovation
                initiatives in{" "}
                <strong>
                    {activeFeature ? nameSelector(activeFeature) : "NSW"}
                </strong>
            </p>
            {activeFeature && (
                <p className={styles.paragraph}>
                    Click on a pin to find more about the initiative.
                </p>
            )}
        </div>
    );
}
RegionSummaryPopup.propTypes = {
    nameSelector: PropTypes.func.isRequired,
    activeFeature: PropTypes.object,
    projects: PropTypes.array,
};
export default connect(state => {
    return {
        activeFeature: selectActiveFeature(state),
        projects: selectFilteredProjectsInActiveFeature(state),
    };
})(RegionSummaryPopup);



// WEBPACK FOOTER //
// ./src/components/region-summary-popup/region-summary-popup.js